import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:3000";
const API_V1_URL = `${API_BASE_URL}/v1`;

export function getCustomersAPI(token: string, tenantId: number) {
    return axios.get(`${API_V1_URL}/tenant/customers?tenantId=${tenantId}&includeProducts=true`, {
        headers: { Authorization: `Bearer ${token}` },
    });
}

export function deleteCustomersAPI(token: string, tenantId: number, userId: string) {
    return axios.delete(`${API_V1_URL}/tenant/delete?tenantId=${userId}`, {
        headers: { Authorization: `Bearer ${token}` },
    });
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function updateCustomersAPI(token: string, name: string, userId: string) {
    return axios.put(`${API_V1_URL}/tenant?orgId=${name}`, {
        //Agregar orgID
        headers: { Authorization: `Bearer ${token}` },
    });
}